import { create } from 'zustand'

export type SipStatus = 'no_config' | 'connecting' | 'registered' | 'disconnected'

interface SipStatusStore {
  status: SipStatus
  hasCredentials: boolean
  _setStatus: (s: SipStatus) => void
  _setHasCredentials: (v: boolean) => void
}

export const useSipStore = create<SipStatusStore>((set) => ({
  status: 'no_config',
  hasCredentials: false,
  _setStatus: (status) => set({ status }),
  _setHasCredentials: (hasCredentials) => set({ hasCredentials }),
}))
